<template>
  <div>
    <el-dialog title="权益转移" :append-to-body="true" :modal-append-to-body="true" :close-on-click-modal="falseValue"
               :visible.sync="showDialog" :modal="falseValue" custom-class="dialog-style list-dialog" style="position: absolute; top: -40px;background-color: rgb(38 38 38 / 70%);"
             @close="dialogClose" v-el-drag-dialog v-el-dialog-center>

      <!-- 品牌信息 -->
      <div class="detail-wrap">
        <div class="d-cont edit-mce-box">
          <div class="d-item">
            <div class="title first">
              <b>进行权益转移</b>
            </div>
            <table class="table-detail" style="height: 200px;width:100%;">
              <tbody style="height: 190px;width:100%;">
              <div style="height: 25px;"></div>
              <li colspan="3">
                <th>
                  转移前资产条码:
                </th>
                <td>
                  {{formData.barcode}}
                </td>
              </li>
              <div style="height: 25px;"></div>
              <li>
                <th>
                  <em class="f-red">*</em>
                  转移后资产条码：
                </th >
                <td style="position: relative;">
                    <el-select v-model="formData.newBarcode" placeholder="请选择"
                               style="width:190px!important;position: absolute;top: -6px;">
                      <el-option v-for="item in productOptions0" :key="item.value" :label="item.label"
                                 :value="item.value">
                      </el-option>
                    </el-select>
                </td>
              </li>
              <div style="height: 25px;"></div>
              <li>
                <th>
                  <em class="f-red">*</em>
                  转移理由：
                </th>
                <td  colspan="3">
                  <textarea v-model="formData.transferRemark" placeholder="请填写" style="width:100%;height:80px;"></textarea>
<!--                  <span style="left: 250px;user-select: none;z-index: 999;top: -10px;">{{formData.transferRemark}}/1000</span>-->
                </td>
<!--                <td>-->
<!--                  <el-input type="text" autocomplete="off" v-model="formData.transferRemark" style="width: 165px;" clearable/>-->
<!--                </td>-->
              </li>
              <div style="height: 15px;"></div>
              </tbody>
            </table>
          </div>

        </div>
      </div>
      <span slot="footer" class="dialog-footer">
			  <span class="fl tips" v-if="!selectMulti">注：双击确认选择（单选）</span>
			  <el-button type="primary" plain class="button-sty" @click="dialogClose">
				  <i class="el-icon-close el-icon"></i>
				  取 消
			  </el-button>
			  <el-button type="primary" @click="commitRightsData" class="button-sty">
				  <i class="el-icon-check el-icon"></i>
				  确 定
			  </el-button>
		  </span>
    </el-dialog>

  </div>
</template>

<script>
import {selectDialogMixins} from '@/mixins/selectDialog/index.js';
import pager from '@/components/pager/index.vue';
import store from "@/store";
import api from "@/api/projectApi";
import { mapGetters } from "vuex";

import PhotoUpload from "@/components/formItem/photoUpload.vue";

export default {
  name: 'saleConfigDialog',
  props: ['visiable', 'multi', 'param', 'transferObj','profileId'],
  mixins: [selectDialogMixins],
  components: {PhotoUpload, pager},

  created() {
    this.initSetting()
    if (this.transferObj) {
      this.formData = this.transferObj
    }
    if (this.profileId) {
      this.formData.profileId = this.profileId
    }
  },

  watch: {
    // 'formData.brandId': {
    //   handler(newVal, oldVal) {
    //     this.brandOptions.forEach(item => {
    //       if (item.value === newVal) {
    //         this.formData.brandName = item.label
    //       }
    //     })
    //     // this.formData.brandId = newVal.value
    //     // this.formData.brandName = newVal.label
    //   },
    //   immediate: true,
    //   deep: true
    // },
    // picList1: {
    //   handler(newVal, oldVal) {
    //     this.formData.pic1 = uploadFileFormat(newVal)
    //   },
    //   immediate: true,
    //   deep: true
    // },
    // picList2: {
    //   handler(newVal, oldVal) {
    //     this.formData.pic2 = uploadFileFormat(newVal)
    //   },
    //   immediate: true,
    //   deep: true
    // },
    // picList3: {
    //   handler(newVal, oldVal) {
    //     this.formData.pic3 = uploadFileFormat(newVal)
    //   },
    //   immediate: true,
    //   deep: true
    // },
    // fileList: {
    //   handler(newVal, oldVal) {
    //     this.formData.eleRepariUrl = uploadFileFormat(newVal)
    //   },
    //   immediate: true,
    //   deep: true
    // }
  },

  mounted() {
    this.loadAssetBarcode();
    // this.loadBrandOption()
    // this.loadBuyChannelOption()
    // this.loadProductOption0()
    // this.loadProductOption1()
  },

  computed: {
    ...mapGetters(["permissions"]),
    api() {
      return api
    },
    headers: function () {
      const tenantId = store.getters.userInfo.tenantId
      return {
        'Authorization': "Bearer " + store.getters.access_token,
        'TENANT-ID': tenantId ? tenantId : '1'
      };
    }
  },

  data() {
    return {
      productOptions0: [],
      total: 0,
      filterText: '',
      data: [],
      notCreate: true,

      pageSizes: [10, 20, 100],
      //以上树形
      activeName: 'second',
      dataId: 0,
      showEdit: false,
      vxeOption: {},
      isRouterAlive: true,
      // 查询参数
      formData: {
        profileId: '',
        id: null,
        barcode: '',
        newBarcode: '',
        transferRemark: '',
      },
      showDialog: true,
      falseValue: false,
      selectMulti: true,
      picList1: [],
      picList2: [],
      picList3: [],
      fileList: [],

    };
  },

  methods: {

    // // 加载产品大类
    // loadProductOption0() {
    //   fetchTree({
    //     categoryType: 1,  // 产品
    //     // usable: 1  // 加载启用的
    //   }).then(response => {
    //     this.productOptions0 = []
    //     response.data.data.forEach(item => {
    //       this.productOptions0.push({
    //         label: item.categoryName,
    //         value: item.id
    //       })
    //     })
    //   });
    // },

    loadAssetBarcode() {
      this.$http({
        url: api.basCustAsset.getRightsBarcodeUrl,
        method: 'post',
        data: {
          profileId: this.formData.profileId,
          barcode: this.formData.barcode
        }
      }).then(response => {
        this.productOptions0 = []
        response.data.data.forEach(item => {
          this.productOptions0.push({
            label: item.barcode,
            value: item.assetId
          })
        })
        // this.$message.success('操作成功');
        this.flushed()
      })
    },

    // 当前页面确认按钮逻辑
    commitRightsData() {
      if (this.formData.newBarcode == null || this.formData.newBarcode === '') {
          this.$message.error("请选择转移机器条码")
          return;
      }
      if (this.formData.transferRemark == null || this.formData.transferRemark === '') {
        this.$message.error("请输入转移理由")
        return;
      }
      this.formData.newBarcode = this.formData.newBarcode;
      // this.$emit('commitRightsData', this.formData)
      this.$baseConfirm('您确定要转移权益吗？').then(() => {
        this.$mask.open()
        this.$http({
          url: api.basCustAsset.rightsTransferUrl,
          method: 'post',
          data: this.formData,
          // data: {
          //   id: this.formData.profileId,
          //   newBarcode: this.formData.newBarcode,
          //   transferRemark: this.formData.transferRemark
          // },
          // isLoading: true,
        }).then(res => {
          this.$message.success("转移成功！")
          this.$mask.close()
        })
      });
      this.dialogClose()
    },

  }
};
</script>
<style lang="scss" scoped>
.papers {
  position: absolute;
  left: 292px;
  top: 0px;

  ::v-deep.el-upload-list .el-upload-list__item {
    display: inline-block;
    width: 147px !important;
    margin-right: 14px;
    border-radius: 2px;
    border-color: #e8e8e8;
    margin-top: 7px;
    margin-left: 15px;
    padding: 0px !important;
    background-color: #e1e1e1;
    height: 20px;
  }

}

// ::v-deep .el-dialog {
//     margin-top: 110px !important;
//     overflow: hidden;
// }


.d-item {
  border: 1px solid #ededed;
}

.table-detail {
  padding-left: 35px;
  display: inline-block;
}

.table-detail tr {
  margin-bottom: 10px;
  display: inline-block;

  th {
    font-weight: 400;
    text-align: right;
    width: 112px;
    font-size: 12px;
    position: relative;
    padding: 0 10px 0 4px;
    color: rgba(86, 86, 86, 0.96);

  }

  // td{
  // 	display: inline-block;
  // 	width: 170px !important;
  // }
}

::v-deep tbody tr td .el-input {

  // width: 165px !important;
}

.title b {
  display: inline-block;
  line-height: 28px;
  font-size: 16px;
  font-weight: 600;
  margin-right: 84px;
  vertical-align: middle;
  color: #00c4b3;
  position: relative;
  z-index: 2;
  background: rgba(42, 100, 148, 0.16);
  margin-left: 0px;
  margin-top: 8px;
  padding-left: 12px;
  padding-right: 14px;
  border-radius: 0 28px 28px 0;
}

.detail-wrap {
  background-color: #fff;
  padding: 5px;
}

// 单选框的样式
::v-deep .vxe-grid .vxe-table--render-default .vxe-cell--radio .vxe-radio--icon:before {
  top: -1px;
}

::v-deep.vxe-grid .vxe-table--render-default .vxe-cell--radio .vxe-radio--checked-icon:after {
  top: 0.3em;
}

#containt .grid-height {
  height: 570px;
}

::v-deep .el-dialog {
  // height: 700px;
  overflow: hidden;
}

::v-deep body .dialog-style {
  border-radius: 8px;
  -webkit-box-shadow: 0 0 24px rgba(0, 0, 0, 0.22);
  box-shadow: 0 0 24px rgba(0, 0, 0, 0.22);
  // height: 700px;
  overflow: hidden;
}

/* 注意此处不能有scoped 否则样式无法生效 */
.el-cascader-panel {
  .el-radio__inner {
    border: 0px;
    background: transparent;
  }

  .el-radio__input.is-checked .el-radio__inner {
    background: none;
  }

  .el-radio {
    height: 100%;
    width: 150px;
    position: absolute;
    z-index: 10;
  }
}

.table_main {
  padding-top: 5px;
  padding-left: 5px;
  border: 1px solid #ededed;
  width: calc(100% - 215px);
  border-bottom: none;

  .el-pagination {
    padding: 2px;

  }
}

.left_tree {
  width: 205px;

  .title {
    text-align: left;
    width: 182px;
    padding: 7px 0 5px !important;
    font-size: 13px;
    color: rgba(58, 39, 39, 0.96);

    > span {
      position: relative;
      left: 4px;
      top: -3px;
    }
  }

  ::v-deep.el-tree-node__label {
    width: calc(100% - 32px);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 12px;
    color: rgba(86, 86, 86, 0.96);
  }
}

.tree_icon {
  background: #f0f3ff;
}

// 重新修改tree组件样式
::v-deep.tree-line {
  .el-tree-node {
    position: relative;
    padding-left: 0px;
  }

  .el-tree-node__content {
    margin-top: 0px;
  }

  .el-tree-node__children {
    padding-left: 16px;
  }

  .el-tree-node::before {
    content: '';
    height: 100%;
    width: 1px;
    position: absolute;
    left: -3px;
    top: -26px;
    border-width: 1px;
    border-left: 1px dashed #d9d9d9;
  }

  .el-tree-node:last-child::before {
    height: 38px;
  }

  .el-tree-node::after {
    content: '';
    width: 24px;
    height: 1px;
    position: absolute;
    left: -3px;
    top: 12px;
    border-width: 1px;
    border-top: 1px dashed #d9d9d9;
  }

  & > .el-tree-node::after {
    border-top: none;
  }

  & > .el-tree-node::before {
    border-left: none;
  }

  .el-tree-node__expand-icon {
    font-size: 17px;

    // color: #000;
    &.is-leaf {
      color: transparent;
      // display: none;
    }
  }
}

.btn_zdy {
  margin: 10px;
  border: 1px solid #dcdfe6 !important;
  border-color: #dcdfe6 !important;
  color: #606266 !important;
  font-weight: 400;
  text-align: center;
  background-color: #FBFBFB !important;
}

.btn_zdy:hover {
  color: #00c4b3 !important;
  border: 1px solid #00c4b3 !important;
}

.btn_zdy2 {
  // 选取文件合同按钮
  // margin: 10px 60px;
  // margin-top: 6px;
  border: 1px solid #dcdfe6 !important;
  border-color: #dcdfe6 !important;
  color: #606266 !important;
  font-weight: 400;
  text-align: center;
  background-color: #FBFBFB !important;
}

.btn_zdy2:hover {
  color: #00c4b3 !important;
  border: 1px solid #00c4b3 !important;
}

::v-deep.table-detail .el-upload--picture-card {
  // margin-top: 10px;
  width: 40px;
  height: 40px;
  line-height: 50px !important;
}

::v-deep .el-upload-list .el-upload-list__item {
  display: inline-block;
  width: 40px;
  height: 40px;
  margin-right: 14px;
  border-radius: 2px;
  padding: 0 !important;
  border-color: #e8e8e8;
  margin-top: 0;
  margin-bottom: 10px;
}

::v-deep .el-upload-list .el-upload-list__item .el-upload-list__item-thumbnail {
  width: 40px;
  height: 40px;
  padding: 0 !important;
  position: inherit;
  cursor: pointer;
}
.vxe-grid .vxe-grid--pager-wrapper {
    display: block;
    width: 100%;
    position: fixed;
    bottom: -38px !important;
    position: absolute !important;
    z-index: 9999999;
    background-color: #ffffff;
}

</style>
